module.exports = __webpack_public_path__ + "img/RU.83d89eda.png";